var axios = require('axios');

const defaults = {
    "Content-Type": "application/json; charset=utf-8",
    "Accept": "application/json"
};

var instance = axios.create();

export const backend = function (options) {
    //console.log('reading token');
    //console.log(options);

    let userToken = localStorage.getItem("_t") || sessionStorage.getItem("_t") || null;
    if (options.headers) {
        options.headers["X-Auth-Token"] = userToken;
    } else {
        options.headers = { "X-Auth-Token": userToken };
    }

    return instance({ ...defaults, ...options, url: options.url });
};